import axios from 'axios'
import ElementUI from 'element-ui'
import Vue from 'vue'
import router from '@/router'
// import { Notify } from 'vant';
// import Vue from 'vue'
// import store from '@/store'  // 我此项目没有用到vuex，所以vuex代码的都注释了，需要的自己打开使用

// import {ACCESS_TOKEN} from '@/store/mutation-types'



// 创建 axios 实例
const requests = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // 基础url,如果是多环境配置这样写，也可以像下面一行的写死。
    // baseURL: 'http://zsgl.hblgxy.gdsk.net.cn/',//正式
    // baseURL: 'http://zsgl.hblgxy.dev.gdsk.net.cn', //测试
    timeout: 30000 // 请求超时时间
})

// 错误处理函数
const err = (error) => {
    if (error.response) {
        const data = error.response.data
        // const token = Vue.ls.get(ACCESS_TOKEN)
        if (error.response.status === 401) {
            Vue.prototype.$message({
                type: "error",
                message: '你没有权限。'
            })
            router.push("/login")
            return
        }
        // if (token) {
        //   store.dispatch('Logout').then(() => {
        //     setTimeout(() => {
        //       window.location.reload()
        //     }, 1500)
        //   })
        // }
        Vue.prototype.$message({
            type: "error",
            message: data.message
        });
    }
    return Promise.reject(error)
}

// request interceptor(请求拦截器)
requests.interceptors.request.use(config => {
    //   const token = Vue.ls.get(ACCESS_TOKEN)
    const token = localStorage.getItem('token')
    if (token) {
        config.headers['authorization'] = 'Bearer ' + token // 让每个请求携带自定义 token 请根据实际情况自行修改
    } else {
        // window.location.href = 'login' //没有token重新登录
    }
    return config
}, err)

// response interceptor（接收拦截器）
requests.interceptors.response.use((response) => {
    const res = response.data
    if (res.code !== 0 && res.code !== 200) {
        Vue.prototype.$message({
            type: "error",
            message: data.message || res.msg
        });
        // 401:未登录;
        if (res.code === 401 || res.code === 403 || res.code === 999) {
            Vue.prototype.$message({
                type: "error",
                message: '请登录'
            });
            setTimeout(() => {
                router.push("/login") //没有token重新登录
            }, 1000);
        }
        return Promise.reject('error')
    } else {
        return res
    }
}, err)



export default requests